module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__extrasizes"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "md-theme": "white"
    }
  }, [_c('FreightExtrasizesMenu'), _vm._v(" "), _c('sort-table', {
    ref: "table",
    attrs: {
      "table-id": "freightextrasize",
      "columns": _vm.tableColumns,
      "link": "",
      "per-page": _vm.perPage,
      "total": _vm.extrasizes_amount,
      "tableHeight": "calc(100% - 48px)"
    },
    on: {
      "refresh": _vm.getExtrasizes,
      "create": _vm.addExtrasize
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(_vm.getTypeLabel(scope.item.type)) + " ")]
      }
    }, {
      key: "markup_type",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s((scope.item.markup_type == '2') ? 'Процентная' : 'Числовая') + " ")]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.extrasizes),
      callback: function($$v) {
        _vm.extrasizes = $$v
      },
      expression: "extrasizes"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ccd681a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/extrasize/FreightExtrasizes.vue
// module id = 1057
// module chunks = 0